import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20artistic%20landscape%20with%20flowing%20organic%20shapes%20in%20amber%20and%20cream%20tones%2C%20symbolizing%20growth%20and%20personal%20development%20journey%2C%20soft%20gradients%2C%20ethereal%20atmosphere%2C%20minimalist%20elegant%20composition%2C%20Asian%20aesthetic%20influence%20with%20subtle%20mountain%20silhouettes%20and%20flowing%20lines&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
          alt="亚洲人成长之路"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          亚洲人成长之路
          <span className="block text-2xl md:text-3xl lg:text-4xl font-normal mt-3 text-white/90">
            全方位发展指南
          </span>
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          探索亚洲人成长的核心议题，涵盖职业发展规划、个人成长方法论、文化认同与自我提升。
          为有志于全面发展的亚洲人提供系统性指引，助您突破瓶颈，实现人生目标。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/career-development"
            className="px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            开始探索
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 rounded-lg bg-white/20 text-white border border-white/30 font-medium text-sm hover:bg-white/30 transition-all duration-300 whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}